import { render } from "./ProfileTrustedDevices.vue?vue&type=template&id=7c4ca6b0"
import script from "./ProfileTrustedDevices.vue?vue&type=script&lang=js"
export * from "./ProfileTrustedDevices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__